module.exports = __webpack_public_path__ + "img/pattern_how3.275958cc.svg";